var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BackToTop'),_c('main',[_c('article',{staticClass:"landing"},[_c('LandingHeader'),_c('LandingAccessible'),_c('LandingStock'),_c('LandingBenefits'),_c('LandingSafeguards'),_c('LandingRisks')],1)]),_c('LandingFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }